module.exports = __webpack_public_path__ + "img/exploreScreen.f426a84b.png";